import React, {useState} from 'react'

const Expanding = ({children, label, label_expanded, tall, callback}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const clickHandler = (e) => {
        e.preventDefault();
        setIsExpanded( !isExpanded);
        if(typeof callback === 'function') {
            callback(isExpanded)
        }
    }
    console.log(tall)

    return(
        <div className="expandable-wrapper">
            <div className={`expandable${ isExpanded ? ' open' : ''}${ tall === 'true' ? ' tall': ''}`}>
                {children}
            </div>
            <a 
                className="expandable-toggle"
                href="#expand-toggle"
                onClick={ clickHandler }
            >
                <span className="icon icon-chevron"></span>
                {isExpanded ? label_expanded : label}
            </a>
        </div>
    )
}

export default Expanding;